import { FC } from "react";
import { Stack } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ResourceFilters } from "./ResourceFilters";
import { ResourceFiltersTextViewSourceButton } from "./sourceButtons/ResourceFiltersTextViewSourceButton";
import { WithResourceType } from "../../../../utils/types";

export const ResourceFiltersTextView: FC<WithResourceType> = ({
  resourceType,
}) => {
  return (
    <Stack direction="row" spacing={0.5}>
      <FilterAltIcon fontSize="small" color="primary" />
      <ResourceFilters
        resourceType={resourceType}
        SourceButton={ResourceFiltersTextViewSourceButton}
      />
    </Stack>
  );
};
